<app-admin-header></app-admin-header>
<main><router-outlet></router-outlet></main>
<app-admin-footer></app-admin-footer>
